/*
 * @Description:
 * @Version: 1.0
 * @Author: changfeng
 * @Date: 2024-03-07 13:38:34
 * @LastEditors: changfeng
 * @LastEditTime: 2024-04-25 15:55:50
 */

import { Dropdown, message, Space } from "antd";
import { connect, useDispatch } from "react-redux";

import { UpOutlined } from "@ant-design/icons";

import { fetchChangeTeam, getTeamList } from "@/api/modules/team";
import { useEffect, useState } from "react";
import { setCurrentTeam, setCurrentUser, setTeamList } from "@/redux/modules/global/action";
import MenuIcon from "@/routers/menu_icon";
import icon from "@/assets/icons/menu/切换团队.png";
import { getCurrentUser } from "@/api/modules/user";

const Team = (props: any) => {
	const { currentUser, currentTeam } = props;
	const dispatch = useDispatch();

	const [items, setItems] = useState();

	useEffect(() => {
		getTeamList({
			current: 1,
			pageSize: 50
		}).then(res => {
			dispatch(setTeamList(res.data.list));

			let teamItems = [];
			res.data?.list.forEach(item => {
				teamItems.push({
					key: item.id,
					label: (
						<div onClick={() => handleChangeTeam(item)} key={item.id}>
							{item.name}
						</div>
					)
				});

				if (item.id === currentUser.currentTeamId) {
					dispatch(setCurrentTeam(item));
				}
			});

			if (!currentTeam) {
				dispatch(setCurrentTeam(res.data.list[0]));
			}
			setItems(teamItems);
		});
		// }, 1000);
	}, [currentUser]);

	const handleChangeTeam = item => {
		fetchChangeTeam({ id: item.id }).then(res => {
			if (res.code === 200) {
				message.success("切换成功");
				getCurrentUser().then(res => {
					dispatch(setCurrentUser(res.data));
				});
				dispatch(setCurrentTeam(item));
			}
		});
	};

	const getTeanName = TeamName => {
		if (TeamName?.length > 12) {
			return TeamName.slice(0, 12) + "...";
		} else {
			return TeamName;
		}
	};

	return (
		<div>
			<Dropdown menu={{ items }} placement="topLeft">
				<a onClick={e => e.preventDefault()}>
					<div
						style={{
							display: "flex",
							justifyContent: "space-between"
						}}
					>
						<div className="team">
							<MenuIcon src={icon} />
							<span
								style={{
									color: "#707793",
									fontSize: "14px",
									lineHeight: "20px"
								}}
							>
								{getTeanName(currentTeam?.name)}
							</span>
						</div>
						<UpOutlined style={{ marginLeft: "auto", color: "#707793", fontSize: "10px" }} />
					</div>
				</a>
			</Dropdown>
		</div>
	);
};

const mapStateToProps = (state: any) => state.global;

export default connect(mapStateToProps)(Team);
